/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum CostSummaryType {
    AiAgentActiveAssessments = 'AiAgentActiveAssessments',
    AiAgentTotalAssessments = 'AiAgentTotalAssessments',
    AverageCostPerPeriod = 'AverageCostPerPeriod',
    CombinedTotal = 'CombinedTotal',
    CostOptimizationCloudAccounts = 'CostOptimizationCloudAccounts',
    CostOptimizationImpactedResources = 'CostOptimizationImpactedResources',
    CostOptimizationPotentialSavings = 'CostOptimizationPotentialSavings',
    CostOptimizationRegions = 'CostOptimizationRegions',
    DimensionGroupWithMostAnomalies = 'DimensionGroupWithMostAnomalies',
    MaxPerPeriod = 'MaxPerPeriod',
    MinPerPeriod = 'MinPerPeriod',
    TopCloud = 'TopCloud',
    TopGroupBy = 'TopGroupBy',
    TopRegion = 'TopRegion',
    TopTenant = 'TopTenant',
    Total = 'Total',
    TotalAnomaliesByBilling = 'TotalAnomaliesByBilling',
    TotalAnomaliesByCloudAccount = 'TotalAnomaliesByCloudAccount',
    TotalAnomaliesByEvent = 'TotalAnomaliesByEvent',
    TotalCostImpactByBilling = 'TotalCostImpactByBilling',
    TotalCostImpactByCloudAccount = 'TotalCostImpactByCloudAccount',
    TotalCostImpactByEvent = 'TotalCostImpactByEvent',
    TotalToken = 'TotalToken'
}
